module.exports = __webpack_public_path__ + "media/images/autopilot-preview-placeholder-image-bc0b811dbe73401ae20f56463c5572bd.png";